import { render, staticRenderFns } from "./RequestFreeAccess.vue?vue&type=template&id=549b1911&scoped=true&"
import script from "./RequestFreeAccess.vue?vue&type=script&lang=js&"
export * from "./RequestFreeAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549b1911",
  null
  
)

export default component.exports